import { FLIGHT_CHECK_ACTION, Service } from "@turizi/shared";

export const RentalTemplate: Partial<Service> = {
    required_service_orders: 1,

    self_attrs: [
        {
            key: 'category',
            type: 'text',
            value: null,
            section: 'room_1',
            sort: 2,
        },
        {
            key: 'capacity',
            type: 'text',
            value: null,
            section: 'room_1',
            sort: 3,
        },
    ],
    booking_attrs: [
        {
            key: 'flight_in',
            type: 'text',
            value: null,
            action: FLIGHT_CHECK_ACTION,
            blocked: true,
            sort: 1,
            section: '_2',
        },
        {
            key: 'flight_out',
            type: 'text',
            value: null,
            action: FLIGHT_CHECK_ACTION,
            blocked: true,
            sort: 1,
            section: '_2',
        },
        {
            key: 'pickup_location',
            type: 'text',
            value: null,
            blocked: true,
            sort: 2,
            section: 'address_1',
        },
        {
            key: 'dropoff_location',
            type: 'text',
            value: null,
            blocked: true,
            sort: 3,
            section: 'address_1',
        },
    ]

} as const;

export default RentalTemplate;